export const DEFAULT_BOOTSTRAP_ANIMATION_TIME = 300;